import React, { useState, useRef } from 'react';
import { Upload, message, Spin } from 'antd';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import download from 'downloadjs';
import ImgCrop from 'antd-img-crop';
import { FlexDivCenter } from '../Typography/Typography';

export default function GenerateStudentCard({ disabled, imageUrl, finished }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  const handleChange = async (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
    } else {
      const formData = new FormData();
      if (info) {
        const extension = info.file.name.split('.').pop();
        const newFileModified = new File(
          [info.file.originFileObj],
          `${Date.now().toString()}.${extension}`
        );
        formData.append('file', newFileModified);
        try {
          const res = await axios.post(
            '/reservations/v1/upload-image',
            formData,
            {
              responseType: 'blob',
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }
          );
          const content = res.headers['content-type'];
          console.log({ content });
          download(res.data, 'student-card.pdf', content);
          finished();
          setLoading(false);
        } catch (err) {
          console.log({ err });
          throw err;
        }
      }
    }
  };

  const uploadButton = (
    <div>{loading ? <Spin /> : <span>{t('upload_image')}</span>}</div>
  );

  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt8M = file.size / 1024 / 1024 < 8;
    if (!isLt8M) {
      message.error('Image must smaller than 8MB!');
    }
    return isJpgOrPng && isLt8M;
  }

  return (
    <FlexDivCenter>
      <ImgCrop modalOk="אישור" modalCancel="ביטול" grid rotate>
        <Upload
          disabled={disabled}
          accept="image/*"
          name="avatar"
          listType="picture-card"
          className="avatar-uploader "
          showUploadList={false}
          beforeUpload={beforeUpload}
          onChange={handleChange}
        >
          {imageUrl ? (
            <img src={imageUrl} alt="avatar" style={{ width: '100%' }} />
          ) : (
            uploadButton
          )}
        </Upload>
      </ImgCrop>

      <input ref={inputRef} hidden />
    </FlexDivCenter>
  );
}
